export default "__VITE_ASSET__883ac7f7__"